(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toriyoshi-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('toriyoshi-slideshow')) return;

    class ToriyoshiSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          document.addEventListener('visibilitychange', this.handleVisibility);
          this.applySchedule();
          this.planNextClockCheck();
          this.startAutoplay();
          return;
        }
        this.initialized = true;
        this.viewport = this.querySelector('[data-ty-viewport]');
        this.track = this.querySelector('[data-ty-track]');
        this.slides = [...this.querySelectorAll('[data-ty-slide]')];
        this.prevButton = this.querySelector('[data-ty-prev]');
        this.nextButton = this.querySelector('[data-ty-next]');
        this.dots = this.querySelector('[data-ty-dots]');
        this.empty = this.querySelector('[data-ty-empty]');
        this.activeSlides = [];
        this.activeIndex = 0;
        this.activeKey = '';
        this.isHovering = false;
        this.isFocusInside = false;
        this.editorSelecting = false;
        this.isEditor = Boolean(window.Shopify && window.Shopify.designMode);
        this.previewAll = this.isEditor && this.dataset.previewAll === 'true';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.startX = 0;
        this.startY = 0;

        this.prevButton.addEventListener('click', () => this.manualMove(-1));
        this.nextButton.addEventListener('click', () => this.manualMove(1));

        this.addEventListener('mouseenter', () => {
          this.isHovering = true;
          this.stopAutoplay();
        });
        this.addEventListener('mouseleave', () => {
          this.isHovering = false;
          this.startAutoplay();
        });
        this.addEventListener('focusin', () => {
          this.isFocusInside = true;
          this.stopAutoplay();
        });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.isFocusInside = false;
            this.startAutoplay();
          }
        });

        this.viewport.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) return;
          this.startX = event.touches[0].clientX;
          this.startY = event.touches[0].clientY;
        }, { passive: true });

        this.viewport.addEventListener('touchend', (event) => {
          if (event.changedTouches.length !== 1 || this.activeSlides.length < 2) return;
          const dx = event.changedTouches[0].clientX - this.startX;
          const dy = event.changedTouches[0].clientY - this.startY;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            event.preventDefault(); // スワイプ後に画像リンクを誤タップしない
            this.manualMove(dx < 0 ? 1 : -1);
          }
        }, { passive: false });

        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.manualMove(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.manualMove(1);
          }
        });

        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-ty-slide]');
          if (!slide || !this.slides.includes(slide)) return;
          this.editorSelecting = true;
          this.stopAutoplay();
          const index = this.activeSlides.indexOf(slide);
          if (index !== -1) this.goTo(index, false);
        });
        this.addEventListener('shopify:block:deselect', () => {
          this.editorSelecting = false;
          this.startAutoplay();
        });

        this.handleVisibility = () => {
          if (!document.hidden) this.applySchedule();
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        };
        document.addEventListener('visibilitychange', this.handleVisibility);

        this.applySchedule();
        this.setAttribute('data-ready', '');
        this.planNextClockCheck();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        clearTimeout(this.clockTimer);
        if (this.handleVisibility) document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      tokyoDateParts() {
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Asia/Tokyo',
          year: 'numeric', month: 'numeric', day: 'numeric',
          weekday: 'short', hour: '2-digit', hourCycle: 'h23'
        });
        const parts = Object.fromEntries(
          formatter.formatToParts(new Date()).filter(p => p.type !== 'literal').map(p => [p.type, p.value])
        );
        return {
          day: Number(parts.day),
          hour: Number(parts.hour),
          weekday: parts.weekday
        };
      }

      matchesRule(rule, clock) {
        if (rule === 'always') return true;
        if (this.previewAll) return true;
        if (rule === 'karaage') return clock.weekday === 'Wed' && clock.hour >= 18;
        if (rule === 'zoryosai') return [4, 14, 24].includes(clock.day);
        if (rule === 'niwatoku') return clock.day === 28;
        if (rule === 'toribiyori') {
          return clock.weekday === 'Sun' && [1, 3].includes(Math.ceil(clock.day / 7));
        }
        return false;
      }

      applySchedule() {
        const clock = this.tokyoDateParts();
        const next = this.slides
          .filter(slide => slide.dataset.enabled === 'true' && this.matchesRule(slide.dataset.rule, clock))
          .sort((a, b) => {
            const rankA = a.dataset.rule === 'always' ? 1 : 0;
            const rankB = b.dataset.rule === 'always' ? 1 : 0;
            return rankA - rankB;
          });

        const nextKey = next.map(slide => slide.dataset.blockId).join('|');
        if (nextKey === this.activeKey && this.hasAttribute('data-ready')) return;
        this.activeKey = nextKey;
        this.activeSlides = next;
        this.activeIndex = 0;

        this.slides.forEach(slide => {
          slide.hidden = !next.includes(slide);
        });
        next.forEach((slide, index) => {
          slide.style.order = index;
        });

        const hasMultiple = next.length > 1;
        this.prevButton.hidden = !hasMultiple || this.dataset.showArrows !== 'true';
        this.nextButton.hidden = !hasMultiple || this.dataset.showArrows !== 'true';
        this.dots.hidden = !hasMultiple || this.dataset.showDots !== 'true';
        this.viewport.hidden = next.length === 0;
        this.empty.hidden = next.length !== 0;

        this.createDots();
        this.goTo(0, false);
        this.startAutoplay();
      }

      createDots() {
        this.dots.replaceChildren();
        this.activeSlides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ty-dot';
          dot.setAttribute('aria-label', `${index + 1}枚目：${slide.dataset.title}`);
          dot.addEventListener('click', () => {
            this.goTo(index, true);
            this.startAutoplay();
          });
          this.dots.appendChild(dot);
        });
      }

      goTo(index, animate = true) {
        if (!this.activeSlides.length) return;
        const count = this.activeSlides.length;
        this.activeIndex = (index + count) % count;

        if (!animate) this.track.style.transition = 'none';
        this.track.style.transform = `translate3d(-${this.activeIndex * 100}%, 0, 0)`;
        if (!animate) {
          requestAnimationFrame(() => {
            if (this.isConnected) this.track.style.transition = '';
          });
        }

        this.slides.forEach(slide => {
          const active = slide === this.activeSlides[this.activeIndex];
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          const link = slide.querySelector('a.ty-media');
          if (link) link.tabIndex = active ? 0 : -1;
        });
        [...this.dots.children].forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === this.activeIndex ? 'true' : 'false');
        });
      }

      manualMove(delta) {
        if (this.activeSlides.length < 2) return;
        this.goTo(this.activeIndex + delta, true);
        this.startAutoplay();
      }

      stopAutoplay() {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      startAutoplay() {
        this.stopAutoplay();
        if (
          this.dataset.autoplay !== 'true' ||
          this.activeSlides.length < 2 ||
          this.isHovering || this.isFocusInside ||
          this.editorSelecting || document.hidden || this.reducedMotion
        ) return;
        const interval = Math.max(3000, Number(this.dataset.interval) || 5000);
        this.autoplayTimer = setInterval(() => {
          this.goTo(this.activeIndex + 1, true);
        }, interval);
      }

      planNextClockCheck() {
        clearTimeout(this.clockTimer);
        // 日本時間でも分の切り替わりは共通。正時の直後に再判定する。
        const ms = 60000 - (Date.now() % 60000) + 100;
        this.clockTimer = setTimeout(() => {
          if (!this.isConnected) return;
          this.applySchedule();
          this.planNextClockCheck();
        }, ms);
      }
    }

    customElements.define('toriyoshi-slideshow', ToriyoshiSlideshow);
  })();

  } catch(e) { console.error(e); }
})();
})();
